// extracted by mini-css-extract-plugin
export default {"wrap":"kG-z","subtitle":"lG-z","contentWrap":"mG-z","imgWrap":"nG-z","heading":"oG-z","copy":"pG-z"};